import { render, staticRenderFns } from "./PermissionOrders.vue?vue&type=template&id=705c888d&scoped=true"
import script from "./PermissionOrders.vue?vue&type=script&lang=js"
export * from "./PermissionOrders.vue?vue&type=script&lang=js"
import style0 from "./PermissionOrders.vue?vue&type=style&index=0&id=705c888d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c888d",
  null
  
)

export default component.exports